var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 12.89 12.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-4{fill:#fff;}.cls-4{fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 12.89,
    height: 12.8
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.29,12.69H1.64a1.5,1.5,0,0,1-1.5-1.5V9.68a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v1.51a.5.5,0,0,0,.5.5h9.65a.5.5,0,0,0,.5-.5V9.68a.5.5,0,0,1,1,0v1.51a1.5,1.5,0,0,1-1.5,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.19,5.83a.51.51,0,0,0-.71,0h0L7,8.57V.6a.5.5,0,0,0-.5-.5A.5.5,0,0,0,6,.6v8L3.45,5.86a.51.51,0,0,0-.71,0h0a.5.5,0,0,0,0,.71l3.74,4,3.75-4a.5.5,0,0,0,0-.71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.7d7c9d60ac7554e0cdbc381d4b7f5cad.svg";
export { ForwardRef as ReactComponent };